import { useEffect, useRef, useState } from "react";

import {
  CloseCircleOutlined,
  DeleteOutlined,
  EditFilled,
  MoreOutlined,
} from "@ant-design/icons";
import {
  Box,
  Button,
  Dialog,
  DialogContent,
  IconButton,
  Menu,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useNotification } from "../../../hooks/useNotification.js";
import { JournalAPIService } from "../../../services/api/JournalAPIService";
import { API_ERROR_MESSAGE, API_SUCCESS_MESSAGE, DATE } from "../../../shared/constants";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import ConfirmationDialog from "../../common/ConfirmationDialog.js";
import ActionMenu from "../../../pages/Extra/ActionMenu.js";
import html2canvas from "html2canvas";
import DownloadBackdrop from "../../../pages/Memory_journal/DownloadBackdrop.js";


const CardTemplateEdit = ({
  journalId,
  headingText,
  author,
  date,
  bgColor = "#007aff",
  headingColor = "#ff92ac",
  textColor = "#ffffff",
  textSize = "20px",
  borderColor = "pink",
  headingMargin = "0%",
  imageTopLeft,
  widthSize = "72%",
  disableEye = false,
  editData = false,
  open,
  onClose,
  pageRefreshCallback
}) => {
  const cardRef = useRef(null);
  const { notifyError, notifySuccess } = useNotification();
  const [showEye, setShowEye] = useState(false);
  const [editMode, setEditOpen] = useState(editData);
  const [editableDate, setEditableDate] = useState(dayjs(date));
  const [editableHeadingText, setEditableHeadingText] = useState(headingText);
  const [anchorEl, setAnchorEl] = useState(null);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [downloading, setDownloading] = useState(false);

  const openMenu = Boolean(anchorEl);

  const handleMenuClick = (action) => {
    switch (action) {
      case "edit":
        handleEdit();
        break;
      case "delete":
        handleDelete();
        break;
      case "effect":
        // handleOpenEditor(imgSrc, journalId);
        break;
      case "save":
        handleDownloadImage();
        break;
      case "drag":

        console.log("Drag action triggered");
        // Optional: set some dragging state here
        break;
      default:
        break;
    }
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setShowEye(false);
  };


  const handleCloseDialog = () => {
    onClose();
    setEditOpen(false);
    setShowEye(false);
  };

  const handleEdit = () => {

    setEditOpen(true);
    setShowEye(false);
  };

  const handleSubmit = () => {
    handleCloseDialog();
    setShowEye(false);
  };

  const handleDelete = () => {

    setConfirmDialogOpen(true);
  };

  const handleCancelDelete = () => {
    setConfirmDialogOpen(false);
  };

  const handleConfirmDelete = () => {
    setConfirmDialogOpen(false);

    JournalAPIService.journalDelete(journalId)
      .then((response) => {
        notifySuccess(response.message || API_SUCCESS_MESSAGE.DELETED_SUCCESSFULLY);
        pageRefreshCallback();
      })
      .catch((errResponse) => {
        notifyError(
          errResponse?.response?.data?.message || API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
        );
      });
    handleCloseDialog();
  };

  const handleUpdate = () => {
    JournalAPIService.journalUpdate(journalId, {
      posted_at: dayjs(editableDate).toISOString(),
      media_caption: editableHeadingText,
      author,
    })
      .then((response) => {
        notifySuccess(API_SUCCESS_MESSAGE.UPDATED_SCUCESSFULLY);
        pageRefreshCallback();
      })
      .catch((errResponse) => {
        notifyError(
          errResponse?.response?.data?.message || API_ERROR_MESSAGE.INTERNAL_SERVER_ERROR
        );
      });
    handleCloseDialog();
  };

  const handleDownloadImage = async () => {
    if (!cardRef.current) return;

    try {
      setDownloading(true);

      const canvas = await html2canvas(cardRef.current, {
        useCORS: true,
        backgroundColor: null,
        // scale: 2,
        allowTaint: true,
        logging: false,
        removeContainer: true,
        imageTimeout: 15000,
      });

      const hashCode = (str) => {
        let hash = 0;
        for (let i = 0; i < str.length; i++) {
          hash = (hash << 5) - hash + str.charCodeAt(i);
          hash |= 0;
        }
        return Math.abs(hash % 10000);
      };

      const shortCode = hashCode(journalId);

      const dataUrl = canvas.toDataURL("image/png");
      const link = document.createElement("a");
      link.href = dataUrl;
      link.download = `IMG_${shortCode}.png`;
      link.click();
      notifySuccess(API_SUCCESS_MESSAGE.DOWNLOAD_REEL);
    } catch (error) {
      console.error("Download failed:", error);
    } finally {
      setDownloading(false);
    }
  };

  // const [isModified, setIsModified] = useState(false);
  // useEffect(() => {
  //   console.log({ editableHeadingText, headingText, d: dayjs(editableDate), e: dayjs(date) });
  //   if (editableHeadingText !== headingText || dayjs(editableDate) !== dayjs(date)) {
  //     setIsModified(true);
  //   } else {
  //     setIsModified(false);
  //   }
  // }, [editableDate, editableHeadingText]);

  return (
    <>


      {/* Dialog */}
      <Dialog open={open} onClose={handleCloseDialog} maxWidth="sm" sx={{ width: "100%" }}>
        <DialogContent sx={{ position: "relative", p: 2 }}>
          {editMode ? (
            <Button
              variant="contained"
              onClick={handleUpdate}
              sx={{
                position: "absolute",
                top: 4,
                right: 4,
                zIndex: 10000,
                marginTop: "2px",
                // marginBottom: "1px",
                // margin: "0 16px 0 0",
                fontSize: "0.5rem",
                color:"#ffff",
               background:"#005cff",
               fontFamily:"Poppins",
               textTransform:"none",
                // borderRadius: "24px",
              }}
            >
              Save and Close
            </Button>
          ) : (
            <IconButton
              onClick={handleCloseDialog}
              sx={{ position: "absolute", top: 2, right: 2, zIndex: 10000 }}
            >
              <CloseCircleOutlined />
            </IconButton>
          )}

<IconButton
                        sx={{
                          position: "absolute",
                          top: 40,
                          right: 30,
                          color: "black",
                          zIndex: 1001,
                          width: { xs: "25px", sm: "30px", md: "30px" },
                          height: { xs: "25px", sm: "30px", md: "30px" },
                          "@media (max-width: 440px)": {
                            height: "20px",
                            width: "20px",
                            top:50,
                            right:28
                          },
                          "@media (min-width: 441px) and (max-width: 600px)": {
                            height: "24px",
                            width: "24px",
                            top: 50,
                            right: 28,
                          }
                          // bgcolor: "#ffffffc9",
                        }}
                        // onClick={handleMenuClick}
                      >
                 <ActionMenu action={handleMenuClick} show={true} drag={false} edit={editMode} fullView={false}/>
                  </IconButton>

<Box
        ref={cardRef}
        sx={{
          width: { xs: "100%", sm: "100%", md: "100%" },
          height: { xs: disableEye ? 280 : 250, sm: 348, md: 348 },
          "@media (max-width: 370px)": {
              height: disableEye ? 280 : 280,
            },
          marginTop: {
            xs: disableEye ? "10%" : "0%",
            sm: disableEye ? "6%" : "0%",
            md: disableEye ? "6%" : "0%",
          },
          bgcolor: bgColor,
          borderRadius: "16px",
          color: textColor,
          position: "relative",
          overflow: "hidden",
          textAlign: "center",
          fontFamily: "Arial, sans-serif",
        }}
        onMouseEnter={() => setShowEye(true)}
        onMouseLeave={() => setShowEye(false)}
      >



        {/* Dynamic Images */}
        {imageTopLeft && (
          <Box
            component="img"
            src={imageTopLeft}
            alt="top-left"
            sx={{
              width: "100%",
              height: { xs: disableEye ? "280px" : "250px", sm: "348px", md: "348px" },
            }}
          />
        )}

        {/* Heading */}
        {editMode && editableHeadingText ? (
          <TextField
            id="outlined-basic"
            label=""
            variant="outlined"
            multiline
            rows={2}
            value={editableHeadingText}
            onChange={(e) => setEditableHeadingText(e.target.value)}
            sx={{
              width: "75%",
              position: "absolute",
              top: headingMargin,
    left: "50%",
    transform: "translateX(-50%)",
              "& .MuiInputBase-inputMultiline": {
                textAlign: "center", // horizontal alignment
                fontSize:"0.8rem",
                // paddingTop: "16px", // tweak this for vertical alignment
                paddingBottom: "0px", // optional
                lineHeight: "1.5", // optional: helps tuning vertical spacing
              },
            }}
            InputProps={{
              sx: {
                color: headingColor,
              },
            }}
          />
        ) : (
          <Typography
  sx={{
    width: widthSize,
    position: "absolute",
    top: headingMargin,
    left: "50%",
    transform: "translateX(-50%)",
    fontWeight: "bold",
    fontSize: textSize,
    "@media (min-width: 460px) and (max-width: 800px)": {
      top: author ? headingMargin :"40%"
          },

    "@media (min-width: 375px) and (max-width: 460px)": {
      top: author ? headingMargin :"40%"
          },

    "@media (min-width: 320px) and (max-width: 365px)": {
      fontSize: "0.8rem",
    },

    "@media (max-width: 370px)": {
      fontSize: headingText?.length < 20 ? "1rem" : "0.8rem",
      top: author ? headingMargin : headingText?.length < 20 ? "45%" :"38%"
          },
    color: headingColor,
    textAlign: "center",
  }}
>
  {headingText}
  {author ? (
    <>
      <br />
      <br />
      {author}
    </>
  ) : null}
</Typography>
        )}

        {/* Date */}
        {editMode ? (
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              value={dayjs(editableDate)}
              onChange={(newValue) => setEditableDate(newValue)}
              format={DATE.JOURNAL_FORMAT}
              sx={{
                position: "absolute",
                bottom: 0,
                left: "50%",
                transform: "translateX(-50%)",

                width: 160,
                "& .MuiInputBase-input": {
                  textAlign: "center",
                  padding: "5px",
                  fontSize: { xs: "0.7rem", sm: "0.8rem", md: "0.8rem" },
                  color: textColor,
                },
              }}
            />
          </LocalizationProvider>
        ) : (
          <Typography
            sx={{
              position: "absolute",
              bottom: 0,
              left: "50%",
              transform: "translateX(-50%)",
              fontSize: { xs: "0.8rem", sm: "0.9rem", md: "0.9rem" },
              color: textColor,
              textAlign: "center",
            }}
          >
            {/* {dayjs(date).format(DATE.JOURNAL_FORMAT)} */}
          </Typography>
        )}
      </Box>

      {/* Confirmation Dialog */}
      <ConfirmationDialog
        id="confirmation-dialog-description"
        open={confirmDialogOpen}
        title=""
        description="Are you sure you want to delete this memory?"
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        confirmText="Delete"
        cancelText="Cancel"
        keepMounted={false}
        transition="up"
        loading={false}
      />
        </DialogContent>
      </Dialog>

      <DownloadBackdrop downloading={downloading} />

    </>
  );
};

export default CardTemplateEdit;
